module.exports = __webpack_public_path__ + "static/media/yp.01ba0035.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/yijing/VehicleDepartmentsQuery/views/images/yp.png
// module id = 1897
// module chunks = 174